import Vue from 'vue'
import VueRouter from 'vue-router'
import TrackingApp from './TrackingApp.vue'
import RequestQuota from './RequestQuota.vue'
import ExpressTracking from './ExpressTracking.vue'
import './tracking.css'
import './tracking-nav.css'
import './quota.css'
import './tracking-font.css'
import './unified.css'

Vue.use(VueRouter)
const router = new VueRouter({ mode: 'hash', routes: [{ path: '/', component: TrackingApp }, { path: '/quota', component: RequestQuota }, { path: '/express', component: ExpressTracking }] })
new Vue({ router, render: h => h('router-view') }).$mount('#app')
